import { COLORS_CONFIG, DEFAULT_COLORS } from '@components/widgets/apacheEchart/Commons'
import { widgetsLibrary } from '../widgetsLibrary/widgetsLibrary'
import { getCommonWidget } from '../dashWidgetHelper'

export const GENERAL_INDICATORS = {
    'RESTAURACION_PERSONAL': 'Bebidas y/o productos para quitar la sed, hidratarte, rendir mejor, para activarte, concentrarte o relajarte.',
    'GUSTOS_ANTOJOS': 'Productos y/o bebidas para un antojo tuyo o de alguien más.',
    'SERVICIOS_FINANCIEROS': 'Recargas telefónicas, Retiros o depósitos de dinero o pago de algún servicio.',
    'REUNION': 'Alimentos,bebidas o artículos para organizar o llevar a una reunión.',
    'HAMBRE_EN_MOVIMIENTO': 'Alimentos o bebidas para un desayuno o comida rapido y práctico fuera de casa',
    'HOGAR': 'Compras cotidianas de productos para el cuidado del hogar, higiene personal, farmacia, preservativos y cuidado del bebé y mascotas.',
    'OTRO': 'Otro. Especificar pregunta abierta.',
};


export const DEFAULT_COLORS_NPS = [
    // '#A2D1A2', // Positivo - verde old
    // '#F5B49F', // Negativo - rojo old
    // '#A3D1D6', // Neutro - azul old
    '#a3d977', // Positivo - verde
    '#f5a524', // amarillo
    '#e74c5c', // Negativo - rojo
    '#8CF0EA', // Neutro - azul
    '#F3AF5A', // Naranja - neutro
    '#B29BC2',
    '#F3B6D8',
    '#FFF9B1',
    '#34C0B8',
    '#FFD01B',
    '#F5B49F',
    '#777933',
    '#A668A8',
    '#9A9CCD',
    '#9C6D76',
    '#C0CB0B',
    '#878972',
    '#0C84AD',
    '#C357F2',
    '#986CAF',
    // Colores adicionales únicos
    '#22a06b', // VERDE (OXXO_DEFAULT_COLORS)
    '#f08591', // ROJO (OXXO_DEFAULT_COLORS)
    '#0f4026', // VERDE_OSCURO (OXXO_DEFAULT_COLORS)
    '#AEDD76', // GREEN_2
    '#CD4245', // RED_1
    '#F1E713', // YELLOW
    '#88DD76', // GREEN_1
    '#DB7476', // RED_2
    '#B29BC2', // (ya estaba, pero por si acaso)
    '#A3D1D6', // azul old
    '#A2D1A2', // verde old
    '#F5B49F', // rojo old
];

export const OXXO_DEFAULT_COLORS = {
    ROJO_OSCURO: '#e74c5c',
    ROJO: '#f08591',
    VERDE: '#22a06b',
    AMARILLO: '#f5a524',
    AZUL: '#a3d977',
    VERDE_OSCURO: '#0f4026'
}

export const OXXO_COLORS_STACKED_BAR = {
    1: OXXO_DEFAULT_COLORS.ROJO_OSCURO,
    2: OXXO_DEFAULT_COLORS.ROJO,
    3: OXXO_DEFAULT_COLORS.AMARILLO,
    4: OXXO_DEFAULT_COLORS.AZUL,
    5: OXXO_DEFAULT_COLORS.VERDE,
}


export const OXXO_SCALE_3_COLORS = {
    'promoters': OXXO_DEFAULT_COLORS.VERDE,
    'passives': OXXO_DEFAULT_COLORS.AMARILLO,
    'detractors': OXXO_DEFAULT_COLORS.ROJO_OSCURO,

    'positive': OXXO_DEFAULT_COLORS.VERDE,
    'neutral': OXXO_DEFAULT_COLORS.AMARILLO,
    'negative': OXXO_DEFAULT_COLORS.ROJO_OSCURO,
}

export const OXXO_COLORS_CONFIG_BAR = [
    // Negativo
    {
        color: OXXO_DEFAULT_COLORS.ROJO_OSCURO,
        condition: '<=' as const,
        key: 'value',
        value: 40,
    },
    // Neutro
    {
        color: OXXO_DEFAULT_COLORS.AMARILLO,
        condition: '>' as const,
        key: 'value',
        value: 40,
    },
    // Positivo
    {
        color: OXXO_DEFAULT_COLORS.VERDE,
        condition: '>' as const,
        key: 'value',
        value: 80,
    },
]

export const OXXO_COLORS_CONFIG_SCALE_5 = [
    // Negativo
    {
        color: OXXO_DEFAULT_COLORS.ROJO_OSCURO,
        condition: '<=' as const,
        key: 'value',
        value: 2,
    },
    // Neutro
    {
        color: OXXO_DEFAULT_COLORS.AMARILLO,
        condition: '>' as const,
        key: 'value',
        value: 2,
    },
    // Positivo
    {
        color: OXXO_DEFAULT_COLORS.VERDE,
        condition: '>' as const,
        key: 'value',
        value: 4,
    },
]


export const OXXO_DEFAULT_SCALE_3_COLORS = {
    'promoters': OXXO_DEFAULT_COLORS.VERDE,
    'passives': OXXO_DEFAULT_COLORS.AMARILLO,
    'detractors': OXXO_DEFAULT_COLORS.ROJO,
    'positive': OXXO_DEFAULT_COLORS.VERDE,
    'neutral': OXXO_DEFAULT_COLORS.AMARILLO,
    'negative': OXXO_DEFAULT_COLORS.ROJO,
}

export const GREEN_1 = '#88DD76'
export const GREEN_2 = '#AEDD76'
export const ORANGE = '#F3AF5A'
export const BLUE = '#8CF0EA'
export const RED_2 = '#DB7476'
export const RED_1 = '#CD4245'
export const YELLOW = '#F1E713'





export const getCmID = (code: string): number => {
    if (code === 'venta') return 10651
    else if (code === 'servicio' || code === 'postventa') return 10652
    else return 1
}


export const commonWidgets: CommonWidget = {
    ...widgetsLibrary,
    multipleGaugeByQuestion: {
        ...widgetsLibrary.multipleGaugeByQuestion,
        //@ts-ignore
        config: {
            ...widgetsLibrary.multipleGaugeByQuestion.config,
            colors: OXXO_DEFAULT_COLORS,
            maxValue: 5
        },
    },
    gaugeInsightDataList: {
      ...widgetsLibrary.gaugeInsightDataList,
      //@ts-ignore
      
      config: {
        ...widgetsLibrary.gaugeInsightDataList.config,        
        indicators: [
            {
                  indicator: 'SURVEY_COUNT',
                  grouped: 'formattedTimeBand',
                  keyExtract: ['group_0', 'value', 'groupName','met'],
                  label: 'group',
                  value: 'value',
                  dataType: 'list',
                  singleton: true,
                  historic: false,
                  sort: { 'sortBy': 'value.answeredCount', value: 'desc', },
                  extras: {
                    //groupByLevel: 1, 
                    //geoLocationInclude: [29],//13703,21497,30,6444],
                  }
                },
           {
                key: 'nps',
                indicator: 'oxxo_retail_npm_recomienda',
                grouped: 'formattedTimeBand',
                //criticalMomentId: 29,
                keyExtract: ['group_0', 'group_1' , 'value', 'groupName'],
                //label: 'group_0',
                //value: 'value',
                //sort: { sortBy: 'group_0', value: 'asc' },
                singleton: true,
                dataType: "list",
                extras: {
                  //periods: 8,
                  decimals: 1,
                  
                  //groupByLevel: 1,
                  //geoLocationInclude: [29],
                },
            },
            {
                key: 'SATISFACCION',
                indicator: 'oxxo_retail_gral_npm_satisf_tienda',
                grouped: 'formattedTimeBand',
                keyExtract: [
                    'group',
                    'value',
                    'groupName',
                    'label',
                    'group_0'
                ],
                label: 'groupName',
                value: 'value',
                singleton: true,
                dataType: "list",
                //sort: { sortBy: 'group', value: 'asc' },
                extras: {
                    //periods: 10,
                    decimals: 1,
                    min: 1,
                    max: 5,
                  
                    //groupByLevel: 1,
                    //geoLocationInclude: [29],
                },
            },

        ]
      }
      
    },

}

export const MEDICASUR_SCALE_3_COLORS = {
    'promoters': GREEN_1,
    'passives': ORANGE,
    'detractors': RED_2,
    'positive': GREEN_1,
    'neutral': ORANGE,
    'negative': RED_1,
    1: GREEN_1,
    2: ORANGE,
    3: RED_1,
}

const getCJIndicators = (indicatorsConfig: { [key: string]: any }) => {
    return Object.keys(indicatorsConfig).map(key => ({
        indicator: indicatorsConfig[key].name,
        grouped: undefined,
        keyExtract: ['group', 'value', 'groupId'],
        label: 'group',
        value: 'value',
        singleton: true,
        extras: {
            groupNameFormat: 'description',
            formula: indicatorsConfig[key].formula ?? undefined,
            ...indicatorsConfig[key].extrasFechas ?? undefined
        },
    }));
};



export const getOxxoBloque = (props: {
    mainOnLeft: boolean,
    id: string
    indicator: string,
    position?: number[],
    size?: number[],
    title?: string,
    subtitle?: string,
    helpText?: string,
    extraConfigs?: { [key: string]: any },
    indicators:
    {
        title: string,
        helpText: string,
        indicator: string,
    }[],
}) => {

    const mainSize = props.size ?? [1, props.indicators.length];
    const widgets: any[] = [];
    widgets.push({ title: props.title, size: [4, 1], type: 'label', });

    const mapLables = {
        1: 'Muy insatisfecho',
        2: 'Insatisfecho',
        3: 'Normal',
        4: 'Satisfecho',
        5: 'Muy satisfecho'
    };

    const mainWidget = getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'gaugeGeneric',
        title: props.subtitle,
        size: mainSize,
        helpText: props.helpText,
        indicator: props.indicator,
        mapper: (data: any) => {
            //console.log('Mapper variedad y precios de productos')
            //console.log(data)
            return data;
        },
        extraConfigs: {
            //decimals: 0,
            showHistoric: false,
            colors: OXXO_COLORS_CONFIG_SCALE_5,
            decimals: 1,
            maxValue: 5,
            showPercentage: false,
        }
    });

    if (props.mainOnLeft) {
        widgets.push(mainWidget);
    }

    props.indicators.forEach((ind: any, index: number) => {
        if (index == mainSize[1]) {
            widgets.push({ title: '', size: [1, 1], type: 'empty-space', });
        }
        widgets.push(
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'stackedBar',
                title: ind.title,
                subTitle: ind.subTitle,
                size: [3, 1],
                helpText: ind.helpText,
                indicator: ind.indicator,
                mapper: (data: any) => {
                    return [...data].sort((a: any, b: any) => a.groupId - b.groupId).map((item: any) => ({
                        ...item,
                    }))
                },
                extraConfigs: {
                    colors: OXXO_COLORS_STACKED_BAR,
                    groupLabels: mapLables,
                    showLegend: true,
                }
            })
        );
        if (!props.mainOnLeft) {
            widgets.push(mainWidget);
            props.mainOnLeft = !props.mainOnLeft;
        }
    });



    return widgets;
};




export const getOxxoBloqueGauges = (props: {
    mainOnLeft: boolean,
    id: string
    indicator: string,
    position?: number[],
    size?: number[],
    title?: string,
    subtitle?: string,
    helpText?: string,
    extraConfigs?: { [key: string]: any },
    indicators:
    {
        title: string,
        helpText: string,
        indicator: string,
    }[],
}) => {

    const mainSize = props.size ?? [1, props.indicators.length];
    const widgets: any[] = [];
    widgets.push({ title: props.title, size: [4, 1], type: 'label', });

    widgets.push(
        ...props.indicators.map((ind: any, index: number) =>
            getCommonWidget({
                commonWidgets: commonWidgets,
                name: 'gaugeGeneric',
                key: '-' + index + '-' + ind.indicator,
                title: ind.title,
                size: mainSize,
                helpText: ind.helpText,
                indicator: ind.indicator,
                mapper: (data: any) => {
                    //console.log('Mapper variedad y precios de productos')
                    //console.log(data)
                    return data;
                },
                extraConfigs: {
                    //decimals: 0,
                    showHistoric: false,
                    colors: OXXO_COLORS_CONFIG_SCALE_5,
                    decimals: 1,
                    maxValue: 5,
                    showPercentage: false,
                }
            })     
        ));

    return widgets;
};


export const getOxxoRetailLineDetailedByLeafMonthAndGeo = (
    props: {
        key: string,
        indicator: string,
        title: string,
        position?: number[] | ((filters: FiltersUI) => number[]),
        size?: number[],
        extraConfigs?: { [key: string]: any },
        targetConfig?: { [key: string]: any },
    }
) => {
    return {
        title: props.title ?? 'FALTA',
        // [Column, Row]
        position: props.position ?? [0, 0],
        size: props.size ?? [4, 3],
        widgetName: props.key,
        config: {
            ...widgetsLibrary.lineDetailedByMonthAndGeo.config,
            id: `line-detailed-by-month-and-geo-leaf-${props.key}`,
            decimals: 0,
            ...props.extraConfigs,
            targetConfig: props.targetConfig,
            mapper: (data: any) => {
                //console.log('haLeafLineDetailedByGeoMapper!!!!!!!!')
                //console.log(data)

                const metrics = [
                    { label: 'General', value: data['data-gral'] },
                    ...data['grouped-by-geo']?.map((item: any) => ({
                        label: item.group,
                        value: item.value
                    })),
                    ...data['grouped-by-geo']?.map((item: any) => ({
                        label: item.group + ' (Meta)',
                        value: 0
                    })),
                    ...data['grouped-by-geo-leaf']?.map((item: any) => ({
                        label: item.group,
                        value: item.value
                    })),
                    ...data['grouped-by-geo-leaf']?.map((item: any) => ({
                        label: item.group + ' (Meta)',
                        value: item.value
                    }))
                ]

                const values = {
                    //@ts-ignore
                    value: data['grouped-by-month-and-geo']?.map((item: any, idx: number) => ({
                        ...item,
                        id: idx,
                        category: item.groupName ? item.groupName : item['group_0'],
                        groupName: item['group_1'] ? item['group_1'] : item.label,
                    })),
                    metrics: metrics
                }
                values.value.push(...data['grouped-by-month-and-geo']?.map((item: any, idx: number) => ({
                    ...item,
                    id: idx,
                    category: item.groupName ? item.groupName : item['group_0'],
                    groupName: (item['group_1'] ? item['group_1'] : item.label) + ' (Meta)',
                    group_1: (item['group_1'] ? item['group_1'] : item.label) + ' (Meta)',
                    value: item?.metricTargets?.[props.targetConfig?.targetQuestion]?.[props.targetConfig?.targetMetricType]?.value,
                })));
                //const target = serie?.metricTargets?.[targetQuestion]?.[targetMetricType]?.value

                return values;
            },
            indicators: [
                {
                    key: `grouped-by-month-and-geo`,
                    indicator: props.indicator,
                    grouped: 'formattedMonth,geoLocation',
                    keyExtract: [
                        'group_0',
                        'group_1',
                        'groupId_0',
                        'value',
                        'groupName',
                        'metricTargets'
                    ],
                    label: 'group',
                    value: 'value',
                    sort: { sortBy: 'group_0', value: 'asc' },
                    singleton: true,
                    extras: {
                        periods: 6
                    },
                },
                {
                    key: `data-gral`,
                    indicator: props.indicator,
                    keyExtract: ['value', 'metricTargets'],
                    value: 'value',
                    dataType: 'single',
                    singleton: false,
                    extras: {},
                },
                {
                    key: `grouped-by-geo`,
                    indicator: props.indicator,
                    keyExtract: ['value', 'group', 'groupName', 'metricTargets'],
                    grouped: 'geoLocation',
                    dataType: 'single',
                    singleton: true,
                    extras: {
                        groupNameFormat: 'description',
                        groupByLevel: 1
                    },
                },
                {
                    key: `grouped-by-geo-leaf`,
                    indicator: props.indicator,
                    keyExtract: ['value', 'group', 'groupName', 'metricTargets'],
                    grouped: 'geoLocation',
                    dataType: 'single',
                    singleton: true,
                    extras: {
                        groupNameFormat: 'description'
                    },
                }
            ],
        }
    }
}



export const getOxxoRetailNbsByGeo = (
    props: {
        key: string,
        indicator: string,
        title: string,
        position?: number[] | ((filters: FiltersUI) => number[]),
        size?: number[],
        npsTargetConfig?: boolean,
        extraConfigs?: { [key: string]: any },
        extras?: { [key: string]: any },
        groupByLevel?: number,
        geoLocationInclude?: number[],
        showLegend?: boolean,
        showValues?: boolean,
    }
) => {
    const targetConfig = props.npsTargetConfig ? { targetQuestion: 'nps', targetMetricType: 'NPS' } : undefined;

    return getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByGeo',
            key: props.key,
            title: props.title,
            size: props.size || [2, 2],
            indicator: props.indicator,
                        
            targetConfig,
            extraConfigs: {
              wrapTexts: true,
              colors: DEFAULT_COLORS_NPS,
              showLegend: true,
              ...(props.extraConfigs || {}),
            },
            extras: {
              groupByLevel: props.groupByLevel, 
              geoLocationInclude: props.geoLocationInclude,
            },
            mapper: (data: any) => {
                //console.log("POC - METAS")
                //console.log(data)
                return data.sort((item1: any, item2: any) => item2.value - item1.value);
            }
        });
}





const SHIFT_MOCKS: any = {

    Matutino: {
        id: 1,
        value: 88.6,
        shift: '☀️ Matutino',
        schedule: '06:00 - 14:00',
        responses: '--',
        satisfaction: '--',
        participation: '--',
        palette: 'morning',
        headline: '⭐ Mejor turno',
        insight: 'NPS más alto y mayor participación.',
    },

    Vespertino: {
        id: 2,
        value: 87.2,
        shift: '🌆 Vespertino',
        schedule: '14:00 - 22:00',
        responses: '--',
        satisfaction: '--',
        participation: '--',
        palette: 'evening',
        headline: '⚠ Turno con presión',
        insight: 'Mayor volumen pero NPS por debajo del matutino.',
    },

    Nocturno: {
        id: 3,
        value: 85.3,
        shift: '🌙 Nocturno',
        schedule: '22:00 - 06:00',
        responses: '--',
        satisfaction: '--',
        participation: '--',
        palette: 'night',
        headline: '🚨 Atención prioritaria',
        insight: 'NPS más bajo del día.',
    }
}
export const getOxxoRetailGaugeInsightDataList = (
    props: {
        //key?: string,
        //indicator?: string,
        title?: string,
        size: number[],
        npsTargetConfig?: boolean,
        extraConfigs?: { [key: string]: any },
        extras?: { [key: string]: any },
        groupByLevel?: number,
        geoLocationInclude?: number[],
        showLegend?: boolean,
        showValues?: boolean,

        turno: "Matutino" | "Vespertino" | "Nocturno",
    }
) => {
    //const targetConfig = props.npsTargetConfig ? { targetQuestion: 'nps', targetMetricType: 'NPS' } : undefined;

    return getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'gaugeInsightDataList',
        title: props.title || ('NPS ' + props.turno),

        size: props.size,
        extraConfigs: {
            colors:  OXXO_COLORS_CONFIG_BAR
        },
      
        mapper: (data: any, extra?: any) => {
            
            const apiItem = (data?.nps || [])
                .find((x: any) => x.groupName === props.turno);

            const satItem = (data?.SATISFACCION || [])
                .find((x: any) => x.groupName === props.turno);

            const countItem = (data?.SURVEY_COUNT || [])
                .find((x: any) => x.groupName === props.turno);

            const totalCount = (data?.SURVEY_COUNT || []).reduce((acc:any, cur:any) => {
              return acc + cur.value.answeredCount;
            } , 0);
            const participation = countItem?.value?.answeredCount && totalCount 
              ? (countItem?.value?.answeredCount*100/totalCount).toFixed(2)+"%" 
              : "--";
            return [{
                ...SHIFT_MOCKS[props.turno],
                value: apiItem?.value || "--",
                responses: countItem?.value?.answeredCount || '--',
                satisfaction: satItem?.value || '--',
                participation,
            }]
                
        },
    });
};


